// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__3-2mf","actions":"GroupTable_actions__2NVLk","deleteModalFooter":"GroupTable_deleteModalFooter__1eVUE"};